import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { EntityDialogComponent } from '../../../../_helpers/Modals/entity-dialog/entity-dialog.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { formatDate } from '@angular/common';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { APIHeaderService } from '../../_services/header/API-header';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormArray, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { APIEntityService } from '../../_services/entity/API-entity';
import { saveAs as importedSaveAs } from "file-saver";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Router, ActivatedRoute } from '@angular/router';
import { formControlBinding } from '@angular/forms/src/directives/ng_model';
import { analyzeAndValidateNgModules } from '@angular/compiler';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');


@Component({
  selector: 'app-headers-by-pe',
  templateUrl: './headers-by-pe.component.html',
  styleUrls: ['./headers-by-pe.component.css']
})
export class HeadersByPeComponent implements OnInit {
  maxDate: Date = new Date();

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  // @ViewChild('t1Sort') t1Sort: MatSort;
  // @ViewChild('t2Sort') t2Sort: MatSort;
  // @ViewChild('t3Sort') t3Sort: MatSort;
  @ViewChild(MatSort) sort: MatSort;
  //@ViewChild('dataSourceHeaderSummarySort') dataSourceHeaderSummarySort: MatSort; 'mobileNumber',
  dataSubject = new BehaviorSubject<any[]>([]);
  //Added for Extension
  displayedColumns: string[] = ['verify', 'hdrVerificationTimestamp', 'reason',
 // 'Verification', 
  'urn', 'cli', 'hclass','Validtill', 'htyp', 'sts', 'reg_comments',
  //'Modify','Email', 
  'extension','tmid', 'createdAt', 'updatedAt',
  'suspension_date'];
  noRecord: any;
  dataSourceHeaderSummary: MatTableDataSource<any>;
  noRecordHeaderSummary: any;

  headerForm: FormGroup;
  VerificationStsForm: FormGroup;
  VerificationReasonForm: FormGroup;
  reasonArray: any;


  public modalRef: BsModalRef;

  entity: any = [];
  form1: any = {};

  data: any = { "Entity_ID": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID) };

  form2: any = {};
  filterData: any;
  filterForm: FormGroup;
  dataSource: MatTableDataSource<any>;
  header: any;
  EntityDetails: any;
  showDropdown: boolean;
  showStatusDropdown: boolean;
  // Added
  minLen: boolean = false;
  maxLen:boolean = false;
  specialChar:boolean = false;
  verifyHead: any = {};
  verifyHeadkey: any = {};
  changeStatus: any;
  frmArray: any = []
  VerificationSts = [
    { id: 'yes', sts: 'Yes' },
    { id: 'no', sts: 'No' }
   // { id: 'empty', sts: '' } //Added for Extension
  ];
  default: any = 'empty'
  disableread: boolean[] = [];
  prevURN: any =''
  //Added for Extension
  govtEntity: boolean = false;
  enableScroll: any;
  crtr: any;
  constructor(public dialog: MatDialog,
    private $modal: $ModalManagerService,
    private hs: APIHeaderService,
    private fb: FormBuilder,
    private db: $DBManagerService,
    private es: APIEntityService,
    private modalService: BsModalService,
    private router: Router,


  ) { }
  openDropdown(value) {

    if (value == "Blacklisted flag") {
      this.showDropdown = true;
      this.showStatusDropdown = false;
    }


    else if (value == "Status") {
      this.showStatusDropdown = true;
      this.showDropdown = false;
    }
    else {
      this.showDropdown = false;
      this.showStatusDropdown = false;
    }


  }
  ModifyHeader(urn) {
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Header",
      msg: "Only Mobile & Email can be modified. Do you want to continue?"
    }
    this.modalRef.content.onClose.subscribe(result => {
      if (result == true) {
        this.router.navigateByUrl('/header-modify;urn=' + urn)

      }

    })
  }
  reset() {
    // this.verifyHead = [];
   // this.verifyHeadkey = [];
    this.verifyHeadkey = {};
    this.verifyHead = {};
    this.data = { "Entity_ID": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID) }
    this.getAllheaderregworklist();
    this.showDropdown = false;
    this.showStatusDropdown = false;

  }
  onSubmitFilter(filterForm) {
    if ((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || filterForm.searchBy == "" && !filterForm.startDate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please search by valid criteria'
      });
      return;
    }


    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');


    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');


    var filterType = filterForm.searchBy;
    var param

    if (filterType == "Status") {
      param = filterForm.searchBy2
    }
    else if (filterType == "Blacklisted flag") {
      param = filterForm.searchBy1
    }
    else {
      param = filterForm.search
    }

    if (fdate != "" && ldate == "") {
      ldate = cdate
    }
    if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
      return;
    }


    this.data = {

      "Start_Date": fdate,
      "End_Date": ldate,
      "filterType": filterType,

      "param": param,
      "Entity_ID": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),

    }


    if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && (param == "" && param == null)) {

      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    //else if ((filterType != null && (param == null || param=="")) || ( filterType == "" && !fdate)) {
    else if ((filterType != null && filterType != "") && (param == null || param == "")) {

      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please enter ' + filterType + ' parameter'
      });
    }



    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else {

      this.hs.searchPEHeaderReports(this.data)
        .subscribe(r => {

          this.dataSource = r.Data;
          this.onChangeDataSource(r.Data);
        });
    }
  }
  downloadPEHeaderReports(filterForm) {

    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');


    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');


    var filterType = filterForm.searchBy;
    var param

    if (filterType == "Status") {
      param = filterForm.searchBy2
    }
    else if (filterType == "Blacklisted flag") {
      param = filterForm.searchBy1
    }
    else {
      param = filterForm.search
    }

    if (fdate != "" && ldate == "") {
      ldate = cdate
    }
    if (fdate > ldate) {
      alert("From Date cannot be after To Date")
      return;
    }
    if (fdate == "" && ldate == "" && (filterType == null || filterType == "") && param == "") {
      alert("Please select any option")
    }
    else if (fdate == "" && ldate != "") {
      alert("Please select Start date")
    }
    else {

      var fileName;
      const currentdat = formatDate(now, 'dd-MM-yyyy hh:mm aaa', 'en-US', '+0530');
      this.hs.downloadPEHeaderReports(this.data).subscribe(r => {
        fileName = currentdat + ' Headers.csv';
        importedSaveAs(r, fileName)
        this.$modal.successModal({
          title: 'PE To View List of Headers',
          msg: 'File has been downloaded Successfully'
        });
      })
    }
  }

  ngOnInit() {
    this.headerForm = this.fb.group({
      header: ['', [Validators.required]],
      industry_category: [''],
      industry_type: [''],
      sector: [''],
      entity_name: [''],


    })
    this.VerificationStsForm = this.fb.group({
      VerificationStsArray: this.fb.array([])
    })
    this.VerificationReasonForm = this.fb.group({
      VerificationReason: this.fb.array([])
    })

  

    this.maxDate.setDate(new Date().getDate());

    this.getAllheaderregworklist();
  }


  onChangeDataSource(value) {
   
    
    for (let i = 0; i < value.length; i++) {
     // console.log(value[i].cli)
      //this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue("empty");
      this.disableread[value[i].urn] = true;  

      if(value[i].sts == "A" || value[i].sts == "SC" || value[i].sts == "SV" || value[i].sts == "SU"){
       // console.log("---- ",value[i].sts)
        if(value[i].hdrVerificationStatus && value[i].hdrVerficationReason){
         
          (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))      
         // console.log("-cli--- ",value[i].cli)
          this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue(value[i].hdrVerificationStatus);

          (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', [Validators.required, Validators.minLength(10), Validators.maxLength(100),Validators.pattern(/(^(?![0-9\s]*$)[a-zA-Z0-9 ,.\s]+$)/)]))
          this.VerificationReasonForm.controls.VerificationReason.get(i.toString()).setValue(value[i].hdrVerficationReason);
        }
        else{
          (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', [Validators.required, Validators.minLength(10), Validators.maxLength(100),Validators.pattern(/(^(?![0-9\s]*$)[a-zA-Z0-9 ,.\s]+$)/)]))
          let selectests;
          (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))
            this.VerificationStsForm.controls.VerificationStsArray.get(i.toString()).setValue("empty");
            this.VerificationReasonForm.controls.VerificationReason.get(i.toString()).setValue("");
      }
      }
      else{
        (<FormArray>this.VerificationReasonForm.controls['VerificationReason']).push(this.fb.control('', []))
        let selectests;
        (<FormArray>this.VerificationStsForm.controls['VerificationStsArray']).push(this.fb.control('', []))
          
      }

    }
   // console.log("after for datsouce this.VerificationReasonForm.invalid ",this.VerificationReasonForm.invalid)
    //console.log("this.VerificationReasonForm.controls.VerificationReason ", this.VerificationReasonForm.controls.VerificationReason)
    //console.log("this.VerificationReasonForm.controls.VerificationReason.value[11] ", this.VerificationReasonForm.controls.VerificationReason.value[11])
   // console.log("VerificationReasonForm.get('VerificationReason').controls ",(<FormArray>this.VerificationReasonForm.get('VerificationReason')).controls)
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

  }
  get f() { return this.headerForm.controls; }

  //Added starts here
  get h() {
    return this.VerificationReasonForm.controls;
    // return this.VerificationReasonForm.get('VerificationReason') as FormArray;
  }


  //Added ends here

//Added for Suspension
ModifyExtension(urn : string,value: string) {
  this.modalRef = this.modalService.show(ModalPromptComponent);
  this.modalRef.content.modalDataObj = {
    title: "Header",
    msg: "Do you like to either extend the validity or convert to permanant headers"
  }
  this.modalRef.content.onClose.subscribe(result => {
    if (result == true) {
      this.router.navigateByUrl('/extension-conversion-headers;urn=' + urn)
      
    }

  })
}


verificationBtn(cli: string,urn: string,crtr: string,hid: string,hclass: string,htyp: string,peid: string){
  let finalInput: any = []
  console.log("Object.keys(this.verifyHeadkey).length ",this.verifyHeadkey)
  console.log("this.verifyHead.urn ",this.verifyHead.urn)
  console.log("this.verifyHead.sts ",this.verifyHead.sts)
  let sts = this.verifyHead.sts
  let reason = this.verifyHeadkey.reason
  if(Object.keys(this.verifyHeadkey).length>0 && this.verifyHead.urn == this.verifyHeadkey.urn && this.verifyHeadkey.urn == urn){

   if(this.verifyHeadkey.reason.length < 10){
     this.minLen = true
     return
   }
   else if(this.verifyHeadkey.reason.length > 100){
      this.maxLen = true;
      return
   }
   else if(/^(?:[a-zA-Z0-9\s]+)?$/.test(this.verifyHeadkey.reason) !== true){
      this.specialChar = true
      return
   }
   else{ 
      finalInput = {
        "urn":urn,
        "sts":sts,
        "reason":reason,
        "cli":cli,
        "hid":hid,
        "hclass":hclass,
        "htyp":htyp,
        "peid":peid
      }
   }
  } 
  else if(Object.keys(this.verifyHeadkey).length == 0 || sts == undefined){
    console.log("heerer   ")
    if(Object.keys(this.verifyHeadkey).length == 0){
      console.log("kjkjk")
      reason = "nochange"
    }
    if(sts == undefined){

      sts = "nochange"
    }
    finalInput = {
      "urn":urn,
      "sts":sts,
      "reason": reason,
      "cli":cli,
      "hid":hid,
      "hclass":hclass,
      "htyp":htyp,
      "peid":peid
    }
  }
  else{
   this.$modal.errorModal({
     title: 'Header Verification',
     msg: "Justification is Mandatory"
   });
   return
  }
  if(Object.keys(finalInput).length > 0){
       finalInput = {
        "urn":urn,
        "sts":sts,
        "reason":reason,
        "cli":cli,
        "hid":hid,
        "hclass":hclass,
        "htyp":htyp,
        "peid":peid,
        "orgname": this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
        "Email": this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)
      }
       console.log("this.verifyHead.sts ",this.verifyHead.sts,crtr,sts)
       if(sts == "yes" || sts == "nochange"){
       this.hs.verifyHeader(finalInput)
       .subscribe(r => {
         if(r.status=="ok"){
           this.verifyHead ={};
           this.verifyHeadkey ={};
           finalInput = [];
           this.getAllheaderregworklist()
           this.$modal.successModal({
             title: 'Header Verification',
             msg: 'Header verification has been completed succesfully with verification timestamp '+r.validity
           });
         }
         else{
           this.$modal.errorModal({
             title: 'Header Verification',
             msg: r.message
           });
         }
       })
      }
      else if(sts == 'no' && Object.keys(this.verifyHeadkey).length > 0 && this.verifyHead.urn == this.verifyHeadkey.urn && this.verifyHeadkey.urn == urn ){
          this.suspendHeader(finalInput)
      }
      else{
        this.$modal.errorModal({
          title: 'Header Verification',
          msg: "Please update Justification"
        });
        return
      }
     }
}

suspendHeader(finalInput) {
  this.modalRef = this.modalService.show(ModalPromptComponent);
  this.modalRef.content.modalDataObj = {
    title: "Header Suspension",
    msg: "Are you sure you want to suspend the header. Do you want to continue?",

  }
  this.modalRef.content.onClose.subscribe(result => {
    if (result === true) {
      let data = {
        cli: finalInput.cli,
        sts: "SC",
        hid: finalInput.hid,
        hclass: finalInput.hclass,
        peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
        reason:finalInput.reason,
        htype: finalInput.htyp,
        urn: finalInput.urn,
        "orgname": this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME),    
        "Email": this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)
      }
      this.hs.suspendHeaderByPE(data)
        .subscribe(r => {
          if (r.status == true) {
            this.router.navigateByUrl('/headers-by-pe');
            this.getAllheaderregworklist()
            this.$modal.successModal({
              title: 'Header Suspension/ Revocation',
              msg: "Header has been suspended successfully"
            });
          }
          else {
            this.$modal.errorModal({
              title: 'Header Suspension/ Revocation',
              msg: r.msg
            });
          }
        })
    }
  })
}

RevokePermanentBtn(cli: string, urn: string){
  this.router.navigateByUrl('/header-suspension;urn=' + urn) 
}

// Reactivatehdr(cli: string,urn: string) {
//   this.modalRef = this.modalService.show(ModalPromptComponent);
//   this.modalRef.content.modalDataObj = {
//     title: "Header",
//     msg: "Do you like to reactive the header"
//   }
//   this.modalRef.content.onClose.subscribe(result => {
//     if (result == true) {
//      // this.router.navigateByUrl('/extension-conversion-headers;urn=' + urn)
//      this.data = {
//       "cli": cli,
//       "entityID": this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
//       }
//      this.hs.permanentHeaderReactivation(this.data)
//       .subscribe(r => {

//         this.dataSource = r.Data;
//         this.onChangeDataSource(r.Data);
//       });

//     }

//   })
// }

  getAllheaderregworklist() {
    var data = {
      peid: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID),
      sts: { $in: ["A", "I", "P", "R", "FP","SC","SU","SV"] },
    }

    this.hs.headersbype(data)
      .subscribe(r => {
        this.filterData = r.data;
        for(let i=0;i<r.data.length;i++){
          if((r.data[i].verificationDue == "yes" && r.data[i].hclass == "Permanent") || (r.data[i].sts == "SC" || r.data[i].sts == "SV" || r.data[i].sts == "SU")){
            this.enableScroll = true;
            break;
          }
          
        }
        this.onChangeDataSource(this.filterData);

      })
    var Entityquery = {
      Entity_ID: this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
    }
    this.es.getOneEntityFromMongo(Entityquery)
      .subscribe(r => {
        this.EntityDetails = r
        //Added for Extension
        // if(r.sts == "SC" || r.sts =="SV" || r.sts == "SU"){
        //    console.log("sts are in suspension state set red color")
           
        // }
        if (r.E_Org_Type == 'G'){
          this.govtEntity = true;
          this.headerForm.controls['industry_category'].setValue('Government');
        }
        else if (r.E_Org_Type == 'P')
          this.headerForm.controls['industry_category'].setValue('Private');
        else if (r.E_Org_Type == 'S')
          this.headerForm.controls['industry_category'].setValue('SEBI');
        else if (r.E_Org_Type == 'O')
          this.headerForm.controls['industry_category'].setValue('Others');
        else if (r.E_Org_Type == 'U')
          this.headerForm.controls['industry_category'].setValue('Public Limited Company');
        else
          this.headerForm.controls['industry_category'].setValue('');

        this.headerForm.controls['industry_type'].setValue(r.Entity_Industry);
        this.headerForm.controls['sector'].setValue(r.Entity_Sector);
        this.headerForm.controls['entity_name'].setValue(r.E_Org_Name);

      })
  }
  onSubmit() {

    let header = this.headerForm.get('header').value;


    if (header) {

      this.dataSource.filter = header.trim().toLowerCase();
    }
  }

  // Added 
  onKey(event: any, urn: any) {
    //  let json = {}
    // json["urn"] = urn
    // json["reason"] = event.target.value
   // console.log(" reason ", event.target.value, urn, this.verifyHeadkey.length)
    if(event.target.value !== ""){
       this.verifyHeadkey["urn"] = urn
       this.verifyHeadkey["reason"] = event.target.value
    }

  }

  selected(urn: any, event: any, ind: any,formctrlname: any) {
    console.log("-----")
    if(this.prevURN !== ""){
    this.disableread[this.prevURN] = true;
     }
    if (event !== "empty") {  
    this.disableread[urn] = false;
    this.verifyHead["urn"] = urn
    this.verifyHead["sts"] = event
    this.prevURN = urn
   // this.VerificationReasonForm.controls.VerificationReason.get(formctrlname.toString()).setValue(""); //Testing purpose
    }
    else{
      this.$modal.errorModal({
        title: 'Header Verification',
        msg: "Blank is not allowed for Verify field"
      });
    }
    // 
   // console.log("selected strt this.VerificationReasonForm.invalid ",this.VerificationReasonForm.invalid)
    // let selectjson = {}
    // selectjson["urn"] = urn
    // selectjson["sts"] = event
    // if (event == "empty") {
    //   return
    // }
    // else {
    //   if (this.verifyHead.length > 0) {
    //     for (let j = 0; j < this.verifyHead.length; j++) {
    //       if (this.verifyHead[j].urn == urn) {
    //         this.verifyHead.splice(j,1)
    //         console.log(" deletein g", this.verifyHead[j])
    //         this.verifyHead.push(selectjson)
    //         break;
    //       }
    //       else {
    //         this.verifyHead.push(selectjson)
    //         break;
    //       }
    //     }
    //   }
    //   else {
    //     this.verifyHead.push(selectjson)
    //   }
    // }
    // console.log("selected end this.VerificationReasonForm.invalid ",this.VerificationReasonForm.invalid)
    // console.log("---URN Array---- :", this.verifyHead)

  }


  VerifyHeader(urn: string,verifyTimeDLT: any) {
    //Added for Extension
    if(time_today < verifyTimeDLT){
      this.$modal.errorModal({
        title: 'Header Verification',
        msg: "Verification Time period is not yet completed"
      });
      return
    }
    
    let finalInput: any = []
  
   if(Object.keys(this.verifyHeadkey).length>0 && this.verifyHead.urn == this.verifyHeadkey.urn && this.verifyHeadkey.urn == urn){
    if(this.verifyHeadkey.reason.length < 10){
      this.minLen = true
      return
    }
    else if(this.verifyHeadkey.reason.length > 100){
       this.maxLen = true;
       return
    }
    else if(/^(?:[a-zA-Z0-9\s]+)?$/.test(this.verifyHeadkey.reason) !== true){
       this.specialChar = true
       return
    }
    else{ 
       finalInput = {"urn":urn,"sts":this.verifyHead.sts,"reason":this.verifyHeadkey.reason}
    }
   } 
   else{
    this.$modal.errorModal({
      title: 'Header Verification',
      msg: "Justification is Mandatory"
    });
    return
   }
   if(Object.keys(finalInput).length > 0){
      let inputjson = { 
          "jsonString": finalInput
        }
        this.hs.verifyHeader(inputjson)
        .subscribe(r => {
         // console.log("response ",r)
          if(r.status=="ok"){
            this.verifyHead ={};
            this.verifyHeadkey ={};
            finalInput = [];
            this.getAllheaderregworklist()
            this.$modal.successModal({
              title: 'Header Verification',
              msg: 'Header verification has been completed succesfully!'
            });
          }
          else{
            this.$modal.errorModal({
              title: 'Header Verification',
              msg: r.message
            });
          }
        })
      }
    // return
  //   if(this.verifyHead.length == this.verifyHeadkey.length){
  //   if (this.verifyHead.length > 0 && this.verifyHeadkey.length > 0) {
      
  //     let arr = this.verifyHead.concat(this.verifyHeadkey)
  //     console.log("arr ", arr)
  //     const output = arr.reduce((acc, curr) => {
  //       let obj = acc.find((item) => item.urn === curr.urn);
  //       if (obj) {
  //         acc.map(val => {
  //           console.log("curr", curr)
  //           console.log("va; ,:", val) 
  //           if (val.urn == curr.urn && curr.urn == urn) {
  //             finalInput.push({ "urn": val.urn, "sts": val.sts, "reason": curr.reason })
  //           }
  //         })
  //         return acc
  //       }
  //       return acc.concat([curr])
  //     }, [])
  //     if (finalInput.length > 0) {
  //       console.log("finalInput ", finalInput)
  //       let inputjson = {
  //         "jsonString": finalInput
  //       }
  //       this.hs.verifyHeader(inputjson)
  //       .subscribe(r => {
  //         console.log("response ",r)
  //         if(r.status=="ok"){
  //           this.verifyHead ={};
  //           this.verifyHeadkey ={};
  //           finalInput = [];
  //           this.getAllheaderregworklist()
  //           this.$modal.successModal({
  //             title: 'Header Verification',
  //             msg: 'Header verification has been completed succesfully!'
  //           });
  //         }
  //         else{
  //           this.$modal.errorModal({
  //             title: 'Header Verification',
  //             msg: r.message
  //           });
  //         }
  //       });
  //     }
  //     else{
  //       this.$modal.errorModal({
  //         title: 'Header Verification',
  //         msg: "Justification is mandatory"
  //       });
  //     }
  //   }
  //   else{
  //     if(this.verifyHead.length > 0){
  //       this.$modal.errorModal({
  //         title: 'Header Verification',
  //         msg: "Justification is mandatory"
  //       });
  //     }
  //     else{
  //     this.$modal.errorModal({
  //       title: 'Header Verification',
  //       msg: "Blank is not allowed for Verify field"
  //     });
  //    }
  //   }
  // }
  // else{
  //   if(this.verifyHead.length < this.verifyHeadkey.length){
  //   this.$modal.errorModal({
  //     title: 'Header Verification',
  //     msg: "Blank is not allowed for Verify field"
  //   });
  //  }
  //  else{
  //   this.$modal.errorModal({
  //     title: 'Header Verification',
  //     msg: "Justification is Mandatory"
  //   });
  //  }
  // }
   // console.log("final this.VerificationReasonForm.invalid ",this.VerificationReasonForm.invalid)
 

  }

  RevokeHeader(urn,verifyTime){
    this.router.navigateByUrl('/header-suspension')
  }
}


export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }

}

